const toastSettings = {
    wrapperId: "lukkari-toast-wrapper",
    delay: 5000
};
const getMessagesRootElement = () => {
    let elem = document.getElementById(toastSettings.wrapperId);
    if(!elem) {
        document.body.innerHTML += `<div aria-live="polite" aria-atomic="true" id="${toastSettings.wrapperId}" class="lukkari-toast-wrapper"></div>`;
        elem = document.getElementById(toastSettings.wrapperId);
    }
    return elem;
}
const notifyMessage = (message='', type='success') => {

    let root = getMessagesRootElement();
    let messageId = 'toast_'+ type + '_' + new Date().getTime();
    
    if(root) {
        type = type.toLowerCase();
        if(type !== 'danger' && type !== 'success') 
            type = 'info';

        let messageElement = `<div role="alert" id="${messageId}" aria-live="assertive" aria-atomic="true" class="toast" data-autohide="true" data-delay="${toastSettings.delay}">
            <div class="toast-body alert alert-${type}">
                ${message}
                <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </div>`;

        root.innerHTML += messageElement;

        $('#'+messageId).toast('show');

        setTimeout(() => {
            document.getElementById(messageId).remove();
        }, toastSettings.delay+250);
    }
}

export default notifyMessage;